import { Chip } from "@material-ui/core";
import { Collection, Linked } from "@type-r/models";
import { Flex, asDateTime, span } from "lqx-react";
import React from "react";
import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";
import { Can } from "src/app/services/can";
import { AssetTypesDisplay } from "../api/assetType";
import { CompanyItem } from "../api/company";
import { ImportTemplateCard } from "../api/importTemplateCard";
import { AssetTypeName, Body, Container, Footer, FooterContent, FooterLabel, FooterRow, NameBlock, NameLabel, PolicyCardDate, Row, State, colorStyles } from "../components/item-card-styles";
import { DigiTooltip } from "../shared";
import { ImportTemplatesActions } from "./import-templates-actions";

export const ImportTemplatesCardRenderer = (
    $activeCard: Linked<ImportTemplateCard>,
    $selectedTab: Linked<string>,
    onDelete?) =>
    ({ data, style, index }) => {
        const classes = colorStyles();
        const importTemplateCard: ImportTemplateCard = data.items[index];
        const isActive = Boolean($activeCard.value) && importTemplateCard.id === $activeCard.value.id;
        const importTemplateStatus = () => importTemplateCard && importTemplateCard.isActive ?
            <span className={classes.active}>Active</span> : <span className={classes.inactive}>Inactive</span>

        return (
            <Row style={style}>
                <Flex row grow>
                    <Container {...{ active: isActive ? 'true' : 'false' }} {...{ onClick: () => { $activeCard.set(importTemplateCard); $selectedTab.set('details') } }}>
                        <Body>
                            <Flex row>
                                <Flex column grow>
                                    <NameBlock>
                                        <State>{importTemplateStatus()}</State>
                                        <AssetTypeName> {importTemplateCard.name}
                                            <DefaultChipContent className={classes.chipLabel} importTemplateCard={importTemplateCard} />
                                            <StandardChipContent className={classes.standardChipColor} importTemplateCard={importTemplateCard} />
                                        </AssetTypeName>
                                    </NameBlock>
                                    <Flex row>
                                        <PolicyCardDate>
                                            <NameLabel>
                                                <CompaniesBlock companies={importTemplateCard.companies}></CompaniesBlock>
                                            </NameLabel>
                                        </PolicyCardDate>
                                    </Flex>
                                </Flex>
                                {Can(UserEntitlementCatalogs.EditImportModelPage) && !$activeCard.value &&
                                    <ImportTemplatesActions importTemplateCard={importTemplateCard} onDelete={onDelete} />
                                }
                            </Flex>
                        </Body>
                        <Footer>
                            <Flex column>
                                <FooterRow>
                                    <FooterLabel>Asset Type:</FooterLabel><FooterContent>{AssetTypesDisplay[importTemplateCard.assetTypeId]}</FooterContent>
                                </FooterRow>
                            </Flex>
                            <Flex column grow>
                                <FooterRow style={{ justifyContent: 'flex-end' }}>
                                    <FooterLabel>Created On:</FooterLabel><FooterContent>{asDateTime(importTemplateCard.createdOn)}</FooterContent>
                                </FooterRow>
                            </Flex>
                        </Footer>
                    </Container>
                </Flex>
            </Row>
        )
    }

const CompaniesBlock = ({ companies }: { companies?: Collection<CompanyItem> }) => {
    if (!companies || companies.length < 1) return <></>
    if (companies.length === 1) return <> {companies.first().name} </>

    return (
        <>
            <DigiTooltip tooltipArrow popperArrow title={<CompaniesTooltipContent companies={companies}></CompaniesTooltipContent>} placement="bottom-start">
                <span>{companies.length} Companies </span>
            </DigiTooltip>
        </>
    )
}

const DefaultChipContent = ({ importTemplateCard, className }: { importTemplateCard: ImportTemplateCard, className?: any }) => {
    return importTemplateCard.isDefault && importTemplateCard.isActive
        ? <ChipContainer><Chip label="Default" className={className} variant="outlined" size="small" /></ChipContainer>
        : <></>
}

const StandardChipContent = ({ importTemplateCard, className }: { importTemplateCard: ImportTemplateCard, className?: any }) => {
    return importTemplateCard.isStandard
        ? <ChipContainer><Chip label="Standard" className={className} variant="outlined" size="small" /></ChipContainer>
        : <></>
}

const CompaniesTooltipContent = ({ companies }: { companies?: Collection<CompanyItem> }) => {
    const limit = 10;
    if (!companies) return <></>
    if (companies.length <= limit) return <div> {companies.map(x => <> {x.name} <br /> </>)}</div>;

    const limittedArrayOfCompanies = companies.slice(0, limit);

    return (
        <>
            <div> {limittedArrayOfCompanies.map(x => <> {x.name} <br /> </>)}</div>
            <div> + {companies.length - limit} </div>
        </>
    );
}

const ChipContainer = span({
    marginLeft: '10px'
});
